import OrchestratorAPI from './common';

import {
  ApiInstance,
  CreateValues,
  FindAllOptions,
  UpdateValues,
} from '../models/orchestrator/apiInstance';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/api-instances';

  async findAll(options: FindAllOptions = {}): Promise<ApiInstance[]> {
    const url = this.constructPath('/', options);
    const { apiInstances } = await this.common.getJSON(url);
    return apiInstances.map(this.deserialize);
  }

  async findOneById(id: string): Promise<ApiInstance> {
    const url = this.constructPath(`/${id}`);
    const { apiInstance } = await this.common.getJSON(url);
    return this.deserialize(apiInstance);
  }

  async create(values: CreateValues): Promise<ApiInstance> {
    const url = this.constructPath('/');
    const { apiInstance } = await this.common.postJSON(url, values);
    return this.deserialize(apiInstance);
  }

  async update(id: string, values: UpdateValues): Promise<ApiInstance> {
    const url = this.constructPath(`/${id}`);
    const { apiInstance } = await this.common.patchJSON(url, values);
    return this.deserialize(apiInstance);
  }

  async remove(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return this.common.deleteJSON(url);
  }

  async upsertBasicAuth(id: string, basicAuth: string): Promise<void> {
    const url = this.constructPath(`/${id}/basic-auth`);
    await this.common.putJSON(url, { basicAuth });
  }

  async upsertBearerToken(id: string, bearerToken: string): Promise<void> {
    const url = this.constructPath(`/${id}/bearer-token`);
    await this.common.putJSON(url, { bearerToken });
  }

  async upsertClientSecret(id: string, clientSecret: string): Promise<void> {
    const url = this.constructPath(`/${id}/client-secret`);
    await this.common.putJSON(url, { clientSecret });
  }

  async upsertPrivateKey(id: string, privateKey: string): Promise<void> {
    const url = this.constructPath(`/${id}/private-key`);
    await this.common.putJSON(url, { privateKey });
  }
}
